import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateFn,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, map } from "rxjs/operators";

import { selectShouldHaveAccessToFI } from "./financial-intelligence.selectors";

export const fiGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select(selectShouldHaveAccessToFI).pipe(
    filter((shouldHaveAccessToFI) => shouldHaveAccessToFI),
    map((shouldHaveAccessToFI) =>
      shouldHaveAccessToFI ? true : router.parseUrl("/unauthorized"),
    ),
  );
};
